import MainLayout from '@/common/components/layouts/MainLayout';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Divider } from 'styled-system/jsx';

import CardEnterAction from '@/common/components/cardAction/CardEnterAction';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard';
import LoadingPage from '@/common/pages/LoadingPage';
import ParticipantIncidentActionsWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/ParticipantIncidentActionsWrapper';
import ParticipantCardHeader from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardHeader/ParticipantCardHeader';
import ParticipantCardItem from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardItem/ParticipantCardItem';
import ParticipantCardWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardWrapper/ParticipantCardWrapper';
import { QUERY_PARAMS } from '@/modules/FileDetail/FileDetailLinks';
import { OFFLINE_FILES_LINK } from '@/modules/OfflineFiles/OfflineFilesLinks';
import { getOfflineFileCheckQueryOptions } from '@/modules/OfflineFiles/queries/getOfflineFileCheck/getOfflineFileCheckQueryOptions';
import { css } from 'styled-system/css';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import OfflineShowPhotoInformationModal from '@/modules/OfflineFiles/components/modals/OfflineShowPhotoInformationModal';
import useModal from '@/common/hooks/useModal';

export default () => (
  <MainLayout title="ارسال تصاویر" header="titleHeader">
    <OfflinePhotosUserLIst />
  </MainLayout>
);

const OfflinePhotosUserLIst = () => {
  const { closeModal, open, openModal } = useModal();

  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isPending, isError } = useQuery(
    getOfflineFileCheckQueryOptions({ id: id! }),
  );
  const { getCurrentFileOfflineImages } = useGetOfflineImages();

  const damagedNavigateHandler = (userId: number) => {
    getCurrentFileOfflineImages({
      damagedId: userId ? userId.toString() : undefined,
    }).then(({ hasOffline }) => {
      if (hasOffline) {
        navigate(
          `${OFFLINE_FILES_LINK.sendOfflinePhotos(+id!)}/?${QUERY_PARAMS.sendOfflinePhotos}=${userId}`,
        );
      } else {
        openModal();
      }
    });
  };
  const culpritNavigateHandler = () => {
    navigate(OFFLINE_FILES_LINK.sendOfflinePhotos(+id!));
  };
  if (isError) {
    return <> خطا</>;
  }
  if (isPending) {
    return <LoadingPage />;
  }
  const culprit = data?.offline_list?.culprit;

  return (
    <Box>
      <ParticipantCardWrapper length={data.offline_list.damaged.length}>
        {data.offline_list?.damaged?.map((item, index) => (
          <MainDetailCard className={css({ px: '1rem' })}>
            <ParticipantCardHeader
              participantDetail={{ id: item.damaged_id }}
              index={index + 1}
              status={[]}
            />
            <ParticipantCardItem
              name={item.full_name}
              telephone={item.phone_number}
            />
            <Divider mt="1rem" color="gray-1" />
            <ParticipantIncidentActionsWrapper>
              <CardEnterAction
                enterAction={() => damagedNavigateHandler(item.damaged_id)}
              />
            </ParticipantIncidentActionsWrapper>
          </MainDetailCard>
        ))}{' '}
      </ParticipantCardWrapper>

      {/* culprit*/}
      {culprit ? (
        <ParticipantCardWrapper length={1}>
          <MainDetailCard className={css({ px: '1rem' })}>
            <ParticipantCardHeader participantDetail={undefined} status={[]} />
            <ParticipantCardItem
              name={culprit.full_name}
              telephone={culprit.phone_number}
            />{' '}
            <Divider mt="1rem" color="gray-1" />
            <ParticipantIncidentActionsWrapper>
              <CardEnterAction enterAction={culpritNavigateHandler} />
            </ParticipantIncidentActionsWrapper>
          </MainDetailCard>
        </ParticipantCardWrapper>
      ) : null}
      <OfflineShowPhotoInformationModal
        confirmButtonText="متوجه شدم"
        open={open}
        closeModal={closeModal}
      />
    </Box>
  );
};
